import { Box, Button, Container, Grid, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import DataTable from '../Table';
import Layout from '../Layout';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchIcon from '@material-ui/icons/Search';
import { getAssetDisposalLogs } from '../../ReduxStore/AssetDisposalSlice';
import * as XLSX from 'xlsx';
import GetAppIcon from '@material-ui/icons/GetApp';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import CustomBreadcrumbs from '../Breadcrumb';
import RefreshIcon from '@material-ui/icons/Refresh';
import { formatDateTime } from '../../helpers/DateConvert';

const columns = [
    { id: 'Sr.no', label: 'Sr No', minWidth: 70 },
    { id: 'Action', label: 'Action', minWidth: 50 },
    { id: 'request_ref_no', label: 'Request Ref. No', minWidth: 150 },
    { id: 'disposal_type', label: 'Disposal Type', minWidth: 150 },
    { id: 'division', label: 'Division', minWidth: 150 },
    { id: 'bc_no', label: 'BC NO', minWidth: 100 },
    { id: 'additional_details', label: 'Additional Details', minWidth: 150 },
    { id: 'tech_details', label: 'Tech Specification', minWidth: 150 },
    { id: 'raiser_name', label: 'Requestor Name', minWidth: 150 },
    { id: 'raiser_dept', label: 'Requestor Department', minWidth: 180 },
    { id: 'raiser_date', label: 'Requested Date', minWidth: 150 },
    { id: 'status', label: 'Status', minWidth: 80 },
];


const AssetDisposalTable = () => {
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [assetDisposals, setAssetDisposals] = useState([]);

    const [formData, setFormData] = useState({
        startDate: '',
        endDate: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const searchHandler = async () => {
        if (!formData.startDate) {
            toast.warn("Please select the Start Date first!")
            return
        }
        getAssetDisposals(`?from_time=${formatDateTime(formData.startDate)}&to_time=${formatDateTime(formData.endDate)}&sort=true`)
    }

    const resetHandler = async () => {
        setFormData({ startDate: '', endDate: '' });
        await getAssetDisposals(); // Refresh logs without filters
    };

    const getAssetDisposals = async (param) => {
        try {
            const action = dispatch(getAssetDisposalLogs(param));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                const updatedLogs = res.result.map(log => ({
                    ...log,
                    raiser_date: convertUTCtoIST(log.raiser_date)
                }));
                setAssetDisposals(updatedLogs)
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const exportToExcel = () => {
        // Create a new worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(assetDisposals);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate a buffer and trigger the download
        XLSX.writeFile(workbook, 'Asset_Disposal.xlsx');
    };

    useEffect(() => {
        const fetchData = async () => {
            await getAssetDisposals();
            setLoading(false);
        };
        fetchData();
    }, [])


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset Disposal Table" />
                </Box>

                <Box mt={4} mb={2}>
                    {/* className='log-row' */}
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                size="small"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                size="small"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={searchHandler}
                                // endIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
                                endIcon={<SearchIcon />}
                            >
                                Search
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="customButton"
                                fullWidth
                                onClick={resetHandler}
                                endIcon={<RefreshIcon />}
                            >
                                Reset
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

                {/* <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}
                {/* <div>
                    <Grid container>
                        <Grid item xs={12}>
                            <DataTable data={assetDisposals} columns={columns} pagination={false} />
                        </Grid>
                    </Grid>
                </div> */}
                <div>
                    <Grid container>
                        <Grid item xs={12}>
                            {assetDisposals.length === 0 ? (
                                <Box display="flex" justifyContent="center" mt={4}>
                                    <Box className="no-data-box">
                                        <div className="no-data-text">
                                            No data available for asset disposals.
                                        </div>
                                    </Box>
                                </Box>

                            ) : (
                                <DataTable data={assetDisposals} columns={columns} pagination={false} />
                            )}
                        </Grid>
                    </Grid>
                </div>

                <ToastContainer />
            </Container>
        </Layout>

    )
}

export default AssetDisposalTable